import React from "react";

function NotAppUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 64 64"
    >
      <g data-name="Artboard 32">
        <circle
          cx="32"
          cy="32"
          r="30"
          fill="#c12b35"
          data-original="#c12b35"
        ></circle>
        <path
          fill="#e63a45"
          d="M19.623 47.894a3.5 3.5 0 01-2.475-5.975l24.377-24.394a3.5 3.5 0 014.95 4.95L22.1 46.87a3.492 3.492 0 01-2.477 1.024z"
          data-original="#e63a45"
        ></path>
        <path
          fill="#e63a45"
          d="M59 35a3 3 0 01-3-3 24 24 0 00-48 0 3 3 0 01-6 0 30 30 0 0160 0 3 3 0 01-3 3z"
          data-original="#e63a45"
        ></path>
        <path
          fill="#fff"
          d="M20.089 11.16a24.008 24.008 0 00-7.161 35.412l33.644-33.644a24.034 24.034 0 00-2.661-1.768zM44 52.789a24.005 24.005 0 007.071-35.36L17.428 51.072a24.115 24.115 0 002.66 1.768z"
          data-original="#ffffff"
        ></path>
        <path
          fill="#2b2e33"
          d="M44 15.5V12a4 4 0 00-4-4H24a4 4 0 00-4 4v27.5z"
          data-original="#2b2e33"
        ></path>
        <path
          fill="#e2e7f7"
          d="M21 12a3 3 0 013-3h16a3 3 0 013 3v4.489l-22 22z"
          data-original="#e2e7f7"
        ></path>
        <path
          fill="#2b2e33"
          d="M20 48.5V52a4 4 0 004 4h16a4 4 0 004-4V24.5z"
          data-original="#2b2e33"
        ></path>
        <path
          fill="#e2e7f7"
          d="M24 55a3 3 0 01-3-3v-4.489l22-22V52a3 3 0 01-3 3z"
          data-original="#e2e7f7"
        ></path>
        <path
          fill="#eef1fa"
          d="M32.495 51H43V25.511l-18 18A7.5 7.5 0 0032.495 51zM25 15.1v19.389l18-18V12a3 3 0 00-3-3h-8.9a6.1 6.1 0 00-6.1 6.1z"
          data-original="#eef1fa"
        ></path>
        <path
          fill="#2b2e33"
          d="M24 8l1 4h14l1-4z"
          data-original="#2b2e33"
        ></path>
      </g>
    </svg>
  );
}

export default NotAppUser;